import React, { useEffect, useState } from 'react';
import { TbTriangleFilled, TbTriangleInvertedFilled } from "react-icons/tb";
import DataTable from '../../../Table';


const DetailsModal = ({ closeModal, client, month, ano }) => {
    const [headers, setHeaders] = useState([
        { key: 'etiqueta', label: 'Patrimônio', },
        { key: 'nome_anexo_atual', label: 'Anexo Atual', },
        { key: 'nome_anexo_anterior', label: 'Anexo Anterior', },
        { key: 'usuario', label: 'Usuário', },
        { key: 'marca', label: 'Marca', },
        { key: 'modelo', label: 'Modelo', },
        { key: 'ramal', label: 'Ramal', },
    ]);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-200 p-4" onClick={e => {
            if (e.target === e.currentTarget) closeModal();
        }}>
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-7xl w-full max-h-[90vh] overflow-hidden flex flex-col">
                <div className="relative bg-gradient-to-r from-vox-green-600 to-vox-green-800 px-6 py-6">
                    <div className="absolute top-4 right-4 z-10">
                        <button 
                            onClick={closeModal}
                            className="p-2 text-white hover:text-red-300 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-vox-green-600 rounded-lg"
                        >
                            <span className="text-3xl">&times;</span>
                        </button>
                    </div>
                    <h2 className="text-2xl font-bold text-white">Relatório do Cliente</h2>
                    <h3 className="text-lg text-green-100 mt-2">{client.nome}</h3>
                </div>
                
                <div className="flex-1 overflow-y-auto p-6">
                    <DataTable 
                        data={client.moves} 
                        headers={headers} 
                        itemsPerPage={10} 
                        exportButton={true}
                        docTitle={`Detalhes de Movimentação - ${client?.nome || "Cliente"}`}
                        hasMonthSelection={`${month}/${ano}`} 
                    />
                </div>
                
                <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end">
                    <button
                        onClick={closeModal}
                        className="px-6 py-3 bg-gray-600 hover:bg-gray-700 text-white font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                    >
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DetailsModal;